export default "__VITE_ASSET__DC73wn0z__"